import { BORDER_STYLE, OUTLINE_STYLE, MAIN_STYLE_GROUPS, PADDING_SIDES, PRESS_EVENTS } from '../shared.js'
export const label = {
    displayName: 'Label',

    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                // firmware genuinely draws a background rect for LABEL using exactly these
                // keys (lv_label_design, lv_label.c:1293-1297); padding insets the text
                // (lv_label.c:1527-1534) — previously commented out here as if inert, but
                // they are not. Re-enabled — see FIRMWARE-PARITY-AUDIT.md "label" section.
                // bg_color:           { type: 'color', format: 'hex8' },
                // bg_opa:             { type: 'int', min: 0, max: 255, internal: true },
                radius:             { type: 'int', min: 0, max: 999 },
                ...BORDER_STYLE,
                ...OUTLINE_STYLE,
                padding:            { type: 'int', min: 0, exportSpecial: true },
                ...PADDING_SIDES,
                text_color:         { type: 'color', label: 'Text color' },
                // Pixel size for the selected Font Family (see `font`, below —
                // top-level properties). Meaningless/ignored on the wire when
                // `font` is empty for the bundled device font, or contains a
                // project resource path for a custom font.
                text_font:          { type: 'int', min: 8, label: 'Size (px)' },
                text_font_family:   { type: 'string', internal: true },
                text_letter_space:  { type: 'int', min: 0 },
                text_decor:         { type: 'int', min: 0, max: 3 },
                // Both read unconditionally by lv_obj_init_draw_label_dsc; matter for
                // multi-line break/scroll/loop modes.
                text_line_space:    { type: 'int', min: 0 },
                text_opa:           { type: 'int', min: 0, max: 255 },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        text:     { type: 'string', label: 'Text' },
        template: { type: 'string' },
        align:    { type: 'enum', values: ['left', 'center', 'right', 'auto'] },
        mode:     { type: 'enum', values: ['expand', 'break', 'dots', 'scroll', 'loop', 'crop'] },
        swipe:    { type: 'bool' },
        groupid:  { type: 'int', min: 0, max: 15, exportSpecial: true },
        entityid: { type: 'string', internal: true },
        // Font Family selection. Its value is the actual wire-format string
        // written to `text_font` verbatim (see Exporter._processFonts()) — one
        // of the fixed internal sentinels in src/utils/internalFonts.js, or a
        // project Font Resource's on-device `file` path. Not a Designer uuid:
        // the Designer/exporter have no special-case logic for which kind of
        // string it is — only the firmware FontManager resolves it. Deliberately
        // NOT `internal: true` (unlike chart.js's `dataset`) — the generic wire
        // export must carry it through to Exporter._processFonts() unchanged;
        // there's no per-widget objectExport() override reintroducing it.
        // `inline: true` — rendered directly in the main properties list
        // (PropertiesPanel.vue, next to `text_font_family`), not via the
        // generic resourceProperties Accordion loop (unlike chart's `dataset`).
        font:     { type: 'resource', resourceType: 'font', label: 'Font Family', inline: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 40, min_width: 40, min_height: 20,
            enabled: true, hidden: false,
            text: 'Text', template: '',
            mode: 'crop', align: 'left', font: '',
        },
        styles: {
            main: { text_font_family: 'Roboto Condensed', text_font: 16 },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_action', 'has_group'],

    convertTo: ['btn','switch','checkbox','led'],

    // Labels receive the same touch lifecycle events as other interactive
    // objects. `down` is the firmware's press event name.
    events: PRESS_EVENTS,

    bindings: {
        properties: {
            x: {}, y: {}, w: {}, h: {},
            // border_width: {}, radius: {}, border_color: {},
            text_font: {}, text: {}, text_color: {},
        },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'] },
    },
}
